<div class="story-share-overlay">
  <brt-share-overlay [url]="shareUrl"></brt-share-overlay>

  <div class="story-share-overlay__checkbox">
    <label>
      <input type="checkbox" (change)="onInputChanged($event)">
      <span class="custom-checkbox"><brt-icon [icon]="'check'"></brt-icon></span>
      <span>Ab dieser Karte teilen<span>{{data.cardIndex}} / {{data.totalCards}}</span></span>
    </label>

  </div>

</div>
